import React, { useState, useRef, useEffect } from 'react';

// 📱 COMPONENTE MOBILE-FIRST
const MenuItem = ({ icon, text, onClick, color = '#e0e0e0', isLogout = false, isPremium = false }) => {
  return (
    <button
      onPointerDown={onClick} 
      style={{
        background: 'transparent',
        border: 'none', 
        color: isLogout ? '#ff4444' : (isPremium ? '#ffd700' : color), // Oro per il Premium
        padding: '12px 20px', textAlign: 'left', cursor: 'pointer',
        fontSize: '15px', fontWeight: isPremium ? '700' : '500', display: 'flex', 
        alignItems: 'center', gap: '12px', width: '100%',
        borderTop: isLogout ? '1px solid #1a1a1a' : 'none',
        marginTop: isLogout ? '5px' : '0',
        paddingTop: isLogout ? '15px' : '12px',
      }}
    >
      <span style={{ fontSize: '16px' }}>{icon}</span> {text}
    </button>
  );
};


// Funzione pura a Whitelist per verificare se il browser è sicuro per il Login Google
const isSecureBrowserForGoogle = (ua) => {
    if (!ua) return false;
    const uaLower = ua.toLowerCase();

    // Cintura di sicurezza extra: escludiamo i marcatori espliciti dei social noti
    if (/instagram|fban|fbav|tiktok|micromessenger|bytedance|musical_ly/i.test(uaLower)) {
        return false;
    }

    // Controllo Android
    if (uaLower.includes("android")) {
        if (uaLower.includes("; wv")) return false; // WebView Android certa
        return uaLower.includes("chrome") || uaLower.includes("crios");
    }

    // Controllo iOS (iPhone, iPad, iPod)
    if (uaLower.includes("iphone") || uaLower.includes("ipad") || uaLower.includes("ipod")) {
        const hasVersion = uaLower.includes("version/");
        const hasSafari = uaLower.includes("safari/");
        const isChromeIOS = uaLower.includes("crios");
        return isChromeIOS || (hasVersion && hasSafari); // Safari standalone vero o Chrome iOS
    }

    // Di default, i browser Desktop sono considerati sicuri
    return true;
};

const LoginButton = ({ user, onLogout, mode = "auto", customTitle, onLoginSuccess }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showGuide, setShowGuide] = useState(false); 
  const [showPremiumModal, setShowPremiumModal] = useState(false); // NUOVO STATO VETRINA
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // "idle" | "loading" | "success" | "error"
  const [errorMsg, setErrorMsg] = useState("");
  const menuRef = useRef(null);

  // 📡 IL COLLEGAMENTO AL MOTORE DEI SOLDI REALE (Legge dal Server)
  const [exportsRemaining, setExportsRemaining] = useState(user?.exports_remaining || 0);

  // Sincronizza il contatore al login
  useEffect(() => {
    if (user && user.exports_remaining !== undefined) {
      setExportsRemaining(user.exports_remaining);
    }
  }, [user]);

  // Ascolta l'evento in tempo reale da Home.jsx quando scali un credito
  useEffect(() => {
    const updateCounter = (e) => {
      if (e.detail !== undefined) {
        setExportsRemaining(e.detail);
      }
    };
    window.addEventListener('magicmix_exports_updated', updateCounter);
    return () => window.removeEventListener('magicmix_exports_updated', updateCounter);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('pointerdown', handleClickOutside);
    return () => document.removeEventListener('pointerdown', handleClickOutside);
  }, []);

  // 💰 FUNZIONE PER APRIRE LA CASSA DI STRIPE (Abbonamento da 4€)
  const handleSubscribe = async () => {
    setLoadingPayment(true);
    try {
      const response = await fetch(`/api/create-checkout-session`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include", 
        // Usa l'ID del prodotto ATTIVO (lo stesso usato nel paywall di Home.jsx)
        body: JSON.stringify({ price_id: "price_1TVVna2MfeHS1EKLOIC3bJEF", user_id: user?.user_id })
      });
      const data = await response.json();
      if (data.checkout_url) {
        window.location.href = data.checkout_url;
      } else {
        alert("Errore apertura cassa Pro: " + (data.detail || data.error));
      }
    } catch (error) {
      alert("Errore di rete con Stripe.");
    } finally {
      setLoadingPayment(false);
    }
  };

  // 🔋 MOTORE DELLA RICARICA DA 2€ (L'icona intelligente)
  const handleRecharge = async () => {
    setLoadingPayment(true);
    try {
      const response = await fetch(`/api/create-checkout-session`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include", 
        body: JSON.stringify({ price_id: "price_1TVVpc2MfeHS1EKL4kIfPEYU" }) // ID ESATTO 2 EURO
      });
      const data = await response.json();
      if (data.checkout_url) {
        window.location.href = data.checkout_url;
      } else {
        alert("Errore cassa ricarica: " + (data.detail || data.error));
      }
    } catch (error) {
      alert("Errore di rete.");
    } finally {
      setLoadingPayment(false);
    }
  };

  // ⚙️ GESTIONE ABBONAMENTO (PORTALE STRIPE)
  const handleManageSubscription = async () => {
    try {
      const response = await fetch(`/api/create-portal-session`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include"
      });
      const data = await response.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert("Impossibile aprire la gestione abbonamento: " + (data.detail || data.error));
      }
    } catch (error) {
      alert("Errore di rete nell'apertura del portale.");
    }
  };

  if (!user) {
    // Risoluzione dinamica dell'API per evitare cross-talk tra staging e produzione
    const getBackendUrl = () => {
      if (typeof window !== "undefined") {
        const hostname = window.location.hostname;
        if (hostname.includes("test.magicmixapp.ch")) {
          return "https://test.magicmixapp.ch";
        } else if (hostname.includes("magicmixapp.ch")) {
          return "https://magicmixapp.ch";
        }
      }
      return process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL || "https://test.magicmixapp.ch";
    };

    const API = `${getBackendUrl()}/api`;

    // Rilevamento Webview Social (Instagram / TikTok)
    const ua = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
    const isSecure = isSecureBrowserForGoogle(ua);
    const isSocialWebview = !isSecure;

    const handleGoogleLogin = () => {
      window.location.href = `${API}/auth/google`;
    };

    const handleMagicLinkRequest = async (e) => {
      e.preventDefault();
      if (!email || !email.includes("@")) {
        setStatus("error");
        setErrorMsg("Please enter a valid email address.");
        return;
      }

      setStatus("loading");
      try {
        const response = await fetch(`${API}/auth/magic-request`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: email.trim() })
        });
        
        if (!response.ok) {
            const errData = await response.json().catch(() => ({}));
            throw new Error(errData.detail || "Failed to send magic link.");
          }

          // Tracciamento evento form inviato con successo su TikTok Pixel
          if (typeof window !== "undefined" && window.ttq) {
            window.ttq.track('SubmitForm');
          }

          setStatus("success");
          if (onLoginSuccess) onLoginSuccess(email);
      } catch (err) {
        console.error("Magic link error:", err);
        setStatus("error");
        setErrorMsg(err.message || "An error occurred. Please try again.");
      }
    };

      // Se l'utente non è loggato e il componente è invocato in modalità "button" (es. Header)
      if (mode === "button") {
        return (
          <button
            onClick={() => {
              window.dispatchEvent(new CustomEvent('open_auth_modal'));
            }}
            style={{
              backgroundColor: '#1a1a1a', border: '1.5px solid #00f0ff',
              color: '#00f0ff', borderRadius: '20px', padding: '8px 18px',
              fontSize: '13px', fontWeight: 'bold', cursor: 'pointer',
              boxShadow: '0 0 10px rgba(0, 240, 255, 0.2)', transition: 'all 0.2s',
              display: 'flex', alignItems: 'center', gap: '6px'
            }}
          >
            👤 Sign In
          </button>
        );
      }

      return (
        <div style={{ textAlign: 'center', width: '100%', maxWidth: '320px', marginInline: 'auto', padding: '0 10px' }}>

          {/* PULSANTE GOOGLE: Mostrato solo se NON siamo in una webview social */}
          {!isSocialWebview ? (
            <>
              <button
                onClick={handleGoogleLogin}
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  backgroundColor: '#ffffff', color: '#000000', border: 'none',
                  borderRadius: '30px', padding: '12px 30px', fontSize: '15px',
                  fontWeight: 'bold', cursor: 'pointer', gap: '10px', width: '100%',
                  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.5)', marginBottom: '20px',
                  transition: 'opacity 0.2s'
                }}
                onMouseOver={(e) => e.currentTarget.style.opacity = "0.9"}
                onMouseOut={(e) => e.currentTarget.style.opacity = "1"}
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
                  alt="Google logo"
                  style={{ width: '18px', height: '18px' }}
                />
                Continue with Google
              </button>

              {/* Divisore orizzontale */}
              <div style={{ display: 'flex', alignItems: 'center', margin: '15px 0', opacity: 0.3 }}>
                <div style={{ flex: 1, height: '1px', backgroundColor: '#fff' }} />
                <span style={{ padding: '0 10px', fontSize: '11px', color: '#fff', textTransform: 'uppercase', letterSpacing: '1px' }}>or</span>
                <div style={{ flex: 1, height: '1px', backgroundColor: '#fff' }} />
              </div>
            </>
          ) : (
            /* Messaggio per webview social (TikTok / IG) */
            <div style={{ backgroundColor: 'rgba(0, 240, 255, 0.05)', border: '1px solid rgba(0, 240, 255, 0.2)', borderRadius: '8px', padding: '12px', marginBottom: '20px' }}>
              <p style={{ color: '#00f0ff', fontSize: '13px', margin: 0, fontWeight: '500', lineHeight: '1.4' }}>
                🔒 TikTok In-App Browser detected. Enter your email below to receive your instant access link.
              </p>
            </div>
          )}

          {/* COMPONENTE FORM MAGIC LINK */}
          <form onSubmit={handleMagicLinkRequest} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <p style={{ color: '#e0e0e0', fontSize: '13.5px', marginBottom: '8px', lineHeight: '1.4' }}>
              {customTitle || "Enter your email — we'll send you a link to sign in. No password needed."}
            </p>

          <input
            type="email"
            placeholder="name@email.com"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (status === "error") setStatus("idle");
            }}
            disabled={status === "loading" || status === "success"}
            style={{
              padding: '12px 16px',
              borderRadius: '8px',
              border: status === "error" ? '1px solid #ff4a4a' : '1px solid #333',
              backgroundColor: '#121212',
              color: '#fff',
              fontSize: '15px',
              outline: 'none',
              width: '100%',
              boxSizing: 'border-box',
              transition: 'border-color 0.2s'
            }}
          />

          <button
            type="submit"
            disabled={status === "loading" || status === "success"}
            style={{
              padding: '12px',
              borderRadius: '8px',
              border: 'none',
              backgroundColor: status === "success" ? '#10b981' : '#00f0ff',
              color: '#0a0a0a',
              fontSize: '15px',
              fontWeight: 'bold',
              cursor: (status === "loading" || status === "success") ? 'not-allowed' : 'pointer',
              width: '100%',
              transition: 'all 0.2s',
              boxShadow: status === "success" ? 'none' : '0 4px 10px rgba(0, 240, 255, 0.2)'
            }}
          >
            {status === "idle" && "Send Magic Link ⚡"}
            {status === "loading" && "Sending Link..."}
            {status === "success" && "Check Your Inbox! ✔"}
            {status === "error" && "Try Again"}
          </button>

          {/* Messaggi di feedback sotto il modulo */}
          {status === "success" && (
            <p style={{ color: '#10b981', fontSize: '12px', marginTop: '6px', lineHeight: '1.4' }}>
              We sent an access link to <strong>{email}</strong>. Open it from your device to continue!
            </p>
          )}

          {status === "error" && (
            <p style={{ color: '#ff4a4a', fontSize: '12px', marginTop: '6px', lineHeight: '1.4' }}>
              ⚠️ {errorMsg}
            </p>
          )}
        </form>
      </div>
    );
  }


  // Colore del contatore: Diventa rosso se i crediti sono <= 5
  const counterColor = exportsRemaining <= 5 ? '#ff4444' : '#00f0ff';

  return (
    <>
      <div style={{ position: 'relative', pointerEvents: 'auto' }} ref={menuRef}>
        <button 
          onPointerDown={() => setIsOpen(!isOpen)}
          style={{
            width: '45px', height: '45px', borderRadius: '50%',
            backgroundColor: '#1a1a1a', border: '2px solid #00f0ff',
            color: '#fff', 
            cursor: 'pointer', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            fontSize: '20px', boxShadow: '0 0 10px rgba(0, 240, 255, 0.2)'
          }}
        >
          👻
        </button>

        {isOpen && (
          <div style={{
            position: 'absolute', top: '55px', right: '0',
            backgroundColor: '#0a0a0a', border: '1px solid #333',
            borderRadius: '12px', width: '240px', padding: '10px 0',
            boxShadow: '0 10px 30px rgba(0,0,0,0.9)', zIndex: 999999,
            display: 'flex', flexDirection: 'column'
          }}>
            
            {/* IL CONTATORE REALE */}
            <div style={{ padding: '15px 20px', borderBottom: '1px solid #1a1a1a', marginBottom: '5px' }}>
              <span style={{ color: '#888', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 'bold' }}>
                Exports Remaining
              </span>
              <div style={{ color: counterColor, fontSize: '24px', fontWeight: '900', marginTop: '2px', transition: 'color 0.3s' }}>
                {exportsRemaining} <span style={{ color: '#555', fontSize: '16px' }}>/ {user?.status === 'Pro' ? 20 : 0}</span>
              </div>
            </div>

            {/* 🔥 BOTTONE DINAMICO: COMPARE SOLO SE PRO E SE EXPORT <= 5 */}
            {user?.status === 'Pro' && exportsRemaining <= 5 && (
              <MenuItem 
                icon="🔋" 
                text="Recharge 10 Exports (€2.00)" 
                color="#00f0ff"
                onClick={handleRecharge} 
              />
            )}

            {/* IL NUOVO BOTTONE PREMIUM (Oscurato se già Pro) */}
            <MenuItem 
              icon="👑" 
              text={user?.status === 'Pro' ? "Already PRO" : "Upgrade to Pro"} 
              isPremium={user?.status !== 'Pro'}
              color={user?.status === 'Pro' ? "#555" : undefined}
              onClick={() => { 
                if (user?.status !== 'Pro') {
                  setIsOpen(false);
                  setShowPremiumModal(true); 
                }
              }} 
            />

            {/* ⚙️ BOTTONE GESTIONE ABBONAMENTO: SOLO PER UTENTI PRO */}
            {user?.status === 'Pro' && (
              <MenuItem 
                icon="⚙️" 
                text="Manage Subscription" 
                color="#a855f7"
                onClick={() => { setIsOpen(false); handleManageSubscription(); }} 
              />
            )}
            
            <MenuItem icon="📖" text="Quick Guide" onClick={() => { setIsOpen(false); setShowGuide(true); }} />
            <MenuItem icon="⚖️" text="Terms & Privacy" onClick={() => window.open('/legal.html', '_blank')} />
            <MenuItem icon="🔴" text="Logout" onClick={onLogout} isLogout={true} />
            
          </div>
        )}
      </div>

      {/* =========================================
          MODAL PREMIUM (LA VETRINA)
          ========================================= */}
      {showPremiumModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 2147483647, display: 'flex',
          justifyContent: 'center', alignItems: 'center', backdropFilter: 'blur(5px)'
        }}>
          <div style={{
            backgroundColor: '#111', border: '1px solid #ffd700', borderRadius: '15px',
            padding: '30px', width: '90%', maxWidth: '450px', position: 'relative',
            boxShadow: '0 20px 50px rgba(255,215,0,0.1)'
          }}>
            <button 
              onPointerDown={() => setShowPremiumModal(false)}
              style={{
                position: 'absolute', top: '15px', right: '15px', background: 'transparent',
                border: 'none', color: '#888', fontSize: '20px', cursor: 'pointer'
              }}
            >
              ✖
            </button>
            
            <h2 style={{ color: '#fff', marginTop: 0, marginBottom: '25px', letterSpacing: '0.5px', fontSize: '22px', textAlign: 'center' }}>
              <span style={{ fontSize: '26px', marginRight: '10px' }}>👑</span>
              Unlock Full Potential
            </h2>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '30px' }}>
              <div style={premiumItemStyle}>
                <span style={{ fontSize: '20px' }}>✅</span>
                <div>
                  <strong style={{ color: '#fff', display: 'block' }}>Unlimited Previews</strong>
                  <span style={{ color: '#aaa', fontSize: '14px' }}>Experiment, mix, and listen to your creations without limits.</span>
                </div>
              </div>
              
              <div style={premiumItemStyle}>
                <span style={{ fontSize: '20px' }}>✅</span>
                <div>
                  <strong style={{ color: '#fff', display: 'block' }}>20 Monthly Exports</strong>
                  <span style={{ color: '#aaa', fontSize: '14px' }}>Download your mixes in high-quality MP3 or Social Video format.</span>
                </div>
              </div>
              
              <div style={premiumItemStyle}>
                <span style={{ fontSize: '20px' }}>✅</span>
                <div>
                  <strong style={{ color: '#fff', display: 'block' }}>Zero Time Limits</strong>
                  <span style={{ color: '#aaa', fontSize: '14px' }}>Work on full tracks, without cuts or interruptions.</span>
                </div>
              </div>
            </div>

            <button 
              onClick={handleSubscribe}
              disabled={loadingPayment}
              style={{
                width: '100%', padding: '15px', borderRadius: '10px',
                backgroundColor: loadingPayment ? '#555' : '#6366f1',
                color: '#fff', border: 'none', fontSize: '16px', fontWeight: 'bold',
                cursor: loadingPayment ? 'not-allowed' : 'pointer',
                boxShadow: loadingPayment ? 'none' : '0 4px 15px rgba(99, 102, 241, 0.4)',
                transition: 'all 0.3s'
              }}
            >
              {loadingPayment ? 'Opening checkout...' : '🔥 Go PRO - €4.00/mo'}
            </button>

          </div>
        </div>
      )}

      {/* =========================================
          MODAL DELLA QUICK GUIDE (MODIFICATO CON LA NUOVA GUIDA COMPLETA)
          ========================================= */}
      {showGuide && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 2147483647, display: 'flex',
          justifyContent: 'center', alignItems: 'center', backdropFilter: 'blur(5px)'
        }}>
          <div style={{
            backgroundColor: '#111', border: '1px solid #333', borderRadius: '15px',
            padding: '30px', width: '90%', maxWidth: '450px', position: 'relative',
            boxShadow: '0 20px 50px rgba(0,240,255,0.1)', maxHeight: '85vh', overflowY: 'auto'
          }}>
            <button 
              onPointerDown={() => setShowGuide(false)}
              style={{
                position: 'absolute', top: '15px', right: '15px', background: 'transparent',
                border: 'none', color: '#888', fontSize: '20px', cursor: 'pointer'
              }}
            >
              ✖
            </button>
            
            <h2 style={{ color: '#fff', marginTop: 0, marginBottom: '20px', letterSpacing: '1px', fontSize: '22px', textAlign: 'left' }}>
              <span style={{ fontSize: '24px', marginRight: '10px' }}>📖</span>MAGIC MIX — USER GUIDE
            </h2>
            
            {/* INIZIO BLOCCO HOW IT WORKS AGGIORNATO */}
            <div style={{ borderBottom: '1px solid #222', paddingBottom: '15px', marginBottom: '15px', textAlign: 'left' }}>
              <h3 style={{ color: '#00f0ff', fontSize: '16px', margin: '0 0 10px 0' }}>How it Works (4 Steps)</h3>
              <p style={{ color: '#ccc', fontSize: '14px', margin: '6px 0', lineHeight: '1.4' }}>1. <strong>Upload:</strong> Add up to 2 sounds (Audio or Video with auto-extraction).</p>
              <p style={{ color: '#ccc', fontSize: '14px', margin: '6px 0', lineHeight: '1.4' }}>2. <strong>Transition:</strong> Set where the first track stops and the second begins (Power Stop).</p>
              <p style={{ color: '#ccc', fontSize: '14px', margin: '6px 0', lineHeight: '1.4' }}>3. <strong>Preview:</strong> Listen and adjust live until it feels right.</p>
              <p style={{ color: '#ccc', fontSize: '14px', margin: '6px 0', lineHeight: '1.4' }}>4. <strong>Export:</strong> Download your mix as an MP3 or social-ready MP4.</p>
            </div>
            {/* FINE BLOCCO HOW IT WORKS AGGIORNATO */}

            <div style={{ textAlign: 'left' }}>
              <h3 style={{ color: '#00f0ff', fontSize: '16px', margin: '15px 0 10px 0' }}>Control Legend</h3>
              
              <h4 style={{ color: '#888', fontSize: '13px', margin: '10px 0 5px 0', textTransform: 'uppercase' }}>Interface Buttons</h4>
              <div style={guideItemStyle}><span>👀 <strong>PREVIEW</strong> — Listen to your live mix.</span></div>
              <div style={guideItemStyle}><span>🚀 <strong>EXPORT</strong> — Download your final mix.</span></div>
              <div style={guideItemStyle}><span>✂️ <strong>Trim (Scissors)</strong> — Cut your track.</span></div>
              <div style={guideItemStyle}><span>🔄 <strong>Sync (Arrows)</strong> — Synchronize the two tracks.</span></div>
              <div style={guideItemStyle}><span>🎧 <strong>SNAP</strong> — Align your cuts perfectly to the beat.</span></div>
              <div style={guideItemStyle}><span>⏱️ <strong>15s / 30s / 60s</strong> — Smart presets that automatically set the drop point and final duration.</span></div>
              <div style={guideItemStyle}><span>📍 <strong>SET IN</strong> — Manually set the exact entry point of the mix (Red marker).</span></div>
              <div style={guideItemStyle}><span>🎯 <strong>SET OUT</strong> — Manually set the exact end point of the mix (Blue marker).</span></div>

              <h4 style={{ color: '#888', fontSize: '13px', margin: '15px 0 5px 0', textTransform: 'uppercase' }}>Transition Effects</h4>
              <div style={guideItemStyle}><span>📈 <strong>POWER STOP</strong> — Classic vinyl brake effect.</span></div>
              <div style={guideItemStyle}><span>💥 <strong>BEAT DROP</strong> — Bass boost + high impact transition.</span></div>
              <div style={guideItemStyle}><span>📻 <strong>RADIO EQ</strong> — High-pass filter transition (radio/phone effect).</span></div>
            </div>

            <div style={{ marginTop: '20px', paddingTop: '15px', borderTop: '1px solid #222', fontSize: '12px', color: '#666', textAlign: 'left' }}>
              🔒 <strong>Privacy Note:</strong> La tua privacy è importante, i tuoi dati sono al sicuro sotto il tuo profilo. Free accounts can preview unlimited mixes. Exporting requires an active plan or trial.
            </div>

          </div>
        </div>
      )}
    </>
  );
};

const guideItemStyle = {
  fontSize: '15px', padding: '8px 0', borderBottom: '1px solid #222', 
  display: 'flex', flexDirection: 'column', gap: '5px'
};

const premiumItemStyle = {
  display: 'flex', alignItems: 'flex-start', gap: '12px', padding: '10px',
  backgroundColor: '#1a1a1a', borderRadius: '8px'
};

export default LoginButton;